import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[browser]',
})
export class BrowseDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
